export default __webpack_public_path__ + "static/media/usdc.9adc4235.png";